var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02935 0 0 4.0295 0 8.99985C0 13.9705 4.02935 18 9 18C13.9703 18 18 13.9705 18 8.99985C18 4.0295 13.9703 0 9 0ZM9.10515 14.2638C6.20422 14.2638 3.85457 11.9082 3.85457 8.99992C3.85457 6.09173 6.20422 3.73613 9.10515 3.73613C10.5229 3.73613 11.7073 4.2592 12.6165 5.10803L11.1362 6.59181V6.58846C10.585 6.06204 9.88612 5.79235 9.10515 5.79235C7.3725 5.79235 5.96473 7.25959 5.96473 8.99677C5.96473 10.7336 7.37254 12.2044 9.10515 12.2044C10.6771 12.2044 11.7467 11.3029 11.9669 10.066H9.10515V8.013H14.0438C14.1095 8.3649 14.1454 8.73345 14.1454 9.11835C14.1454 12.1254 12.1373 14.2638 9.10515 14.2638Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglem);
export default __webpack_public_path__ + "static/media/googlem.b28bafe31e7732802db6b62c8b7a7533.svg";
export { ForwardRef as ReactComponent };